import * as React from "react";
import * as _ from "lodash";
import { LabelTitle, LabelContainer, InputIconFieldMainContainer, InputIconFieldHoverContainer, ButtonVisibility, ActionContainer, Input, InputContainer, InputLabel, IconContainer, ContentContainer } from './styles';
import { IconErrorSyncContainer, ToolTipContainer, ToolTipLabel, ErrorMessageContainer } from './styles';
import { CharacterCountLine, CharacterLimitLine } from './styles';
import { TCButton } from "components/TCButton";
import { TC_BUTTON_TYPE } from "components/TCButton/constants";
import { KEYS } from "common/constants";
import InnerLoader from "components/InnerLoader";
import { InputSuggestable } from "components/SearchableDropdown/styles";
import { SIZE } from "common/sizes";
import IconErrorSync from 'common/images/icon-error-sync.svg'

export interface InputIconFieldProps {
    value?: string
    placeholder?: string
    label?: string
    readonly?: boolean
    state?: InputIconFieldState
    disabled?: boolean
    disableBackground?: boolean
    showAlertIcon?: boolean
    alertToolTip?: string
    showEditErrorMessage?: boolean
    editErrorMessage?: string
    disableSave?:boolean
    minCharacters?: number
    maxCharacters?: number
    showCharacterCount?: boolean
    showCharacterLimit?: boolean
    characterCount?: number

    renderIcon?: () => any
    renderValue?: (state: InputIconFieldState) => any

    onChange?: (value: string) => void
    onActionClick?: (action: InputIconFieldAction) => void
}

export enum InputIconFieldState {
    READ_ONLY = "READ_ONLY",
    EDIT = "EDIT",
    VIEW = "VIEW",
    LOADING = "LOADING"
}

export enum InputIconFieldAction {
    SAVE = "SAVE",
    EDIT = "EDIT",
    CANCEL = "CANCEL",
}

const InputIconField = (props: InputIconFieldProps) => {
    const [displayEditButton, setDisplayEditButton] = React.useState<boolean>(false)
    const iconField = React.useRef<HTMLElement | undefined>();
    const [fieldState, setFieldState] = React.useState(props.readonly ? InputIconFieldState.READ_ONLY : InputIconFieldState.VIEW)
    const [internalcharacterCount, setInternalcharacterCount] = React.useState(props.characterCount!==undefined?props.characterCount:(props.value?props.value.length:0))
    
    React.useEffect(() => {
        setInternalcharacterCount(props.value?props.value.length:0);
    }, [props.value])

    React.useEffect(() => {
        if (props.characterCount !== undefined) {
            setInternalcharacterCount(props.characterCount);
        }
    }, [props.characterCount])

    const state = React.useMemo(() => {
        if (props.state) {
            return props.state
        }
        return fieldState
    }, [props.state, fieldState]);

    return (
        <InputIconFieldHoverContainer
            editing={state === InputIconFieldState.EDIT}
            onMouseOver={() => setDisplayEditButton(true)}
            onMouseLeave={() => setDisplayEditButton(false)}
        >
            <InputIconFieldMainContainer
                ref={iconField as any}
                onKeyPress={onKeyPress}
            >
                {
                    renderContent()
                }

            </InputIconFieldMainContainer>
        </InputIconFieldHoverContainer>
    )

    function onInputChange(event) {
        setInternalcharacterCount((event?.target?.value?(event?.target?.value.length):0));
        if (props.onChange && state === InputIconFieldState.EDIT) {
            props.onChange(event?.target?.value ?? "")
        }
    }

    function onButtonClick(event, action) {
        if (props.onActionClick) {
            if (action === InputIconFieldAction.EDIT) {
                setFieldState(InputIconFieldState.EDIT)
                props.onActionClick(InputIconFieldAction.EDIT)
            }

            if (action === InputIconFieldAction.SAVE) {
                setFieldState(InputIconFieldState.VIEW)
                props.onActionClick(InputIconFieldAction.SAVE)
            }

            if (action === InputIconFieldAction.CANCEL) {
                setFieldState(InputIconFieldState.VIEW)
                props.onActionClick(InputIconFieldAction.CANCEL)
            }
        }
    }


    function onKeyPress(event: { key: string }) {
        if (event && event.key) {
            switch (event.key) {
                case KEYS.ESCAPE:
                    {

                    }
                    break;
                case KEYS.TAB:
                case KEYS.ENTER:
                    {

                    }
                    break;
            }
        }
    }

    function renderButtons() {
        if (state === InputIconFieldState.VIEW) {
            return (
                <ButtonVisibility
                    visibility={displayEditButton
                    }>
                    <TCButton
                        type={TC_BUTTON_TYPE.LISMA}
                        onClick={(event) => onButtonClick(event, InputIconFieldAction.EDIT)}
                        disabled={props.disabled}
                    >
                        {
                            "Edit"
                        }
                    </TCButton>
                </ButtonVisibility>
                
            )
        } else {
            return (
                <>
                    <TCButton
                        type={TC_BUTTON_TYPE.LISMA}
                        onClick={(event) => onButtonClick(event, InputIconFieldAction.CANCEL)}
                        disabled={props.disabled}
                        backgroudColor={"#112240"}
                    >
                        {
                            "Cancel"
                        }
                    </TCButton>
                    <TCButton
                        type={TC_BUTTON_TYPE.LISMA}
                        onClick={(event) => onButtonClick(event, InputIconFieldAction.SAVE)}
                        disabled={props.disabled || props.disableSave || !isInsideLimits()}                        
                    >
                        {
                            "Save"
                        }
                    </TCButton>
                </>
            )
        }

    }

    function isInsideLimits(): boolean {
        let insideLimits = true;
        if (props.minCharacters !== undefined) {
            if (internalcharacterCount < props.minCharacters) insideLimits = false;
        }
        if (props.maxCharacters !== undefined) {
            if (internalcharacterCount > props.maxCharacters) insideLimits = false;
        }
        return insideLimits;
    }

    function getCharacterCount(): string {
        let characterCountText = "Character Count: " + internalcharacterCount.toString();
        if (props.maxCharacters !== undefined) {
            characterCountText += "/" + props.maxCharacters.toString();
        }
        return characterCountText;
    }

    function getCharacterLimitText(): string {
        let characterLimitText = "Character Limit: ";
        if (props.minCharacters !== undefined) {
            characterLimitText += "Min " + props.minCharacters;
            if (props.maxCharacters !== undefined) {
                characterLimitText += ", ";
            }
        }
        if (props.maxCharacters !== undefined) {
            characterLimitText += "Max " + props.maxCharacters;
        }
        return characterLimitText;
    }

    function renderContent() {
        if (state === InputIconFieldState.READ_ONLY) {
            return (
                <>
                    {
                        props.renderIcon &&
                        <IconContainer>
                            {
                                props.renderIcon()
                            }
                        </IconContainer>

                    }
                    <InputContainer editable={false}>
                        {
                            props.renderValue ?
                                props.renderValue(state)
                                :

                                <InputLabel>
                                    {
                                        props.value
                                    }
                                </InputLabel>
                        }
                    </InputContainer>
                </>
            )
        } else {
            return (
                <ContentContainer>
                    < LabelContainer >
                        {
                            props.renderIcon &&
                            <IconContainer>
                                {
                                    props.renderIcon()
                                }
                            </IconContainer>

                        }


                        {
                            props.label &&
                            <>
                                <LabelTitle showAlertIcon={props.showAlertIcon && state === InputIconFieldState.VIEW}>
                                    {props.label}
                                </LabelTitle>
                                {
                                    props.showAlertIcon  && state === InputIconFieldState.VIEW &&
                                    <IconErrorSyncContainer>
                                        <img src={IconErrorSync}/>
                                        <ToolTipContainer>
                                            <ToolTipLabel>
                                                {props.alertToolTip}
                                            </ToolTipLabel>
                                        </ToolTipContainer>
                                    </IconErrorSyncContainer>
                                }
                            </>
                        }
                        <ActionContainer editable={state === InputIconFieldState.EDIT}>
                            {
                                state === InputIconFieldState.LOADING ?
                                    <InnerLoader />
                                    :
                                    renderButtons()
                            }
                        </ActionContainer>
                    </LabelContainer >
                    <InputContainer margin={`${SIZE.ONE}px 0 0 ${SIZE.SEVEN}px`} editable={!props.disableBackground && state === InputIconFieldState.EDIT}>
                        {
                            props.renderValue ?
                                props.renderValue(state)
                                :
                                state === InputIconFieldState.EDIT ?
                                    <Input
                                        placeholder={props.placeholder}
                                        onChange={onInputChange}
                                        value={props.value}
                                    />
                                    :
                                    <InputLabel>
                                        {
                                            props.value
                                        }
                                    </InputLabel>
                        }
                    </InputContainer>
                    {
                        state === InputIconFieldState.EDIT && props.showCharacterCount &&
                        <CharacterCountLine>
                            {getCharacterCount()}
                        </CharacterCountLine>
                    }
                    {
                        state === InputIconFieldState.EDIT && props.showCharacterLimit && (props.minCharacters !== undefined || props.maxCharacters !== undefined) &&
                        <CharacterLimitLine limitsAlert={!isInsideLimits()}>
                            {getCharacterLimitText()}
                        </CharacterLimitLine>
                    }
                    {
                        props.showEditErrorMessage  && state === InputIconFieldState.EDIT &&
                        <ErrorMessageContainer>
                            {props.editErrorMessage}
                        </ErrorMessageContainer>
                    }
                </ContentContainer>
            )
        }
    }
}

export default InputIconField;